var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "550px" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Merge Config")]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      _c("r-item-merge-mode", {
                        attrs: { model: _vm.mode },
                        on: {
                          "update:model": function ($event) {
                            _vm.mode = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "mt-3",
                        attrs: {
                          label: "Only First Reward",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.model.onlyFirstReward,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "onlyFirstReward", $$v)
                          },
                          expression: "model.onlyFirstReward",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "mt-3",
                        attrs: { label: "Ignore Copycat", "hide-details": "" },
                        model: {
                          value: _vm.model.ignoreCopycat,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "ignoreCopycat", $$v)
                          },
                          expression: "model.ignoreCopycat",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "pt-4", attrs: { dense: "" } },
                [
                  _c(
                    "v-expansion-panels",
                    {
                      model: {
                        value: _vm.panels,
                        callback: function ($$v) {
                          _vm.panels = $$v
                        },
                        expression: "panels",
                      },
                    },
                    [
                      _c(
                        "v-expansion-panel",
                        { attrs: { disabled: _vm.mode.id !== 2 } },
                        [
                          _c("v-expansion-panel-header", {
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ open }) {
                                  return [
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-top": "5px",
                                            },
                                          },
                                          [_vm._v("Generator:")]
                                        ),
                                        _c("v-spacer"),
                                        _c("v-fade-transition", [
                                          open
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    display: "inline-flex",
                                                  },
                                                },
                                                [
                                                  _c("v-divider", {
                                                    staticClass: "mx-1",
                                                    attrs: { vertical: "" },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c("r-item-generator-model", {
                                attrs: { model: _vm.model.generator },
                                on: {
                                  "update:model": function ($event) {
                                    return _vm.$set(
                                      _vm.model,
                                      "generator",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("r-reward-panel", {
                        attrs: {
                          disabled: _vm.mode.id == 0,
                          model: _vm.model.reward,
                          title: "Rewards",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "reward", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }